import { render } from "./AnnotationSetListItem.vue?vue&type=template&id=af8e2b0a&scoped=true"
import script from "./AnnotationSetListItem.vue?vue&type=script&lang=js"
export * from "./AnnotationSetListItem.vue?vue&type=script&lang=js"

import "./AnnotationSetListItem.vue?vue&type=style&index=0&id=af8e2b0a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8e2b0a"]])

export default __exports__